import Select from "@components/core/Select";
import { DependencyTypeSelectorProps } from "@customTypes/components/selectors/DependencyTypeSelector";

import { beadlSelector, DependencyType } from "@store/beadl";
import { useCallback } from "react";
import { useSelector } from "react-redux";
import { itemIdentifier, renderLabel } from "../util";

const DependencyTypeSelector = (props: DependencyTypeSelectorProps) => {
  const {
    selected,
    onChange,
    placeholder = "Select a dependency",
    options,
    className,
    allowClear,
    onClear,
  } = props;

  const { dependencyTypes: { data: dependencyTypes } } = useSelector(beadlSelector);

  const handleChange = useCallback(
    (id: number, item?: DependencyType) => {
      onChange && onChange(id, item);
    },
    [onChange]
  );

  return (
    <Select
      allowClear={allowClear}
      onClear={onClear}
      className={className}
      options={options || dependencyTypes}
      selected={selected}
      onChange={handleChange}
      placeholder={placeholder}
      labelRender={(item) => renderLabel(item, "name")}
      itemIdentifier={(item) => itemIdentifier(item, "id")}
    />
  );
};

export default DependencyTypeSelector;
